module.exports = __webpack_public_path__ + "static/media/sg.9eb47fe7.svg";